/** Labels for per-branch receipt + internal sale number. */
export const BRANCH_RECEIPT_NUMBER_LABEL = 'Número de Recibo';
export const SALES_ORDER_NUMBER_LABEL = 'Número de Venta';
